// Karnataka cities for the Panchanga location picker
export const KA_CITIES = [
  { id: "bengaluru", kn: "ಬೆಂಗಳೂರು", en: "Bengaluru", lat: 12.9716, lng: 77.5946 },
  { id: "mysuru", kn: "ಮೈಸೂರು", en: "Mysuru", lat: 12.2958, lng: 76.6394 },
  { id: "mangaluru", kn: "ಮಂಗಳೂರು", en: "Mangaluru", lat: 12.9141, lng: 74.8560 },
  { id: "hubballi", kn: "ಹುಬ್ಬಳ್ಳಿ", en: "Hubballi", lat: 15.3647, lng: 75.1240 },
  { id: "udupi", kn: "ಉಡುಪಿ", en: "Udupi", lat: 13.3409, lng: 74.7421 },
  { id: "kalaburagi", kn: "ಕಲಬುರಗಿ", en: "Kalaburagi", lat: 17.3297, lng: 76.8343 },
];
